var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.25,
    height: 21.88,
    viewBox: "0 0 31.25 21.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_003-youtube",
    "data-name": "003-youtube",
    d: "M30.606-2.658a3.915,3.915,0,0,0-2.754-2.755c-2.445-.669-12.227-.669-12.227-.669s-9.781,0-12.227.644A3.994,3.994,0,0,0,.644-2.658,41.252,41.252,0,0,0,0,4.858a41.1,41.1,0,0,0,.644,7.516A3.916,3.916,0,0,0,3.4,15.129c2.471.669,12.227.669,12.227.669s9.781,0,12.227-.644A3.915,3.915,0,0,0,30.606,12.4a41.265,41.265,0,0,0,.643-7.516A39.159,39.159,0,0,0,30.606-2.658Zm-18.1,12.2V.173l8.134,4.685Zm0,0",
    transform: "translate(0 6.082)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.c8bbdb3f5baddf0bbf5fbdbe5b73f2ca.svg";
export { ForwardRef as ReactComponent };